import { render, staticRenderFns } from "./Restock.vue?vue&type=template&id=33e83e48&"
import script from "./Restock.vue?vue&type=script&lang=ts&"
export * from "./Restock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports